import { getPersistentPlayerId } from '../metrics';
import config from '../config.json';
import constants from '@playcastdotio/GlobalConfig';
import { sendAnalytics } from '@playcastdotio/Analytics';

const base = constants.API_BASE_URL;

export const ping = async () => {
  const response = await fetch(base.concat('ping'));
  return await response.json();
};

export const download = async () => {
  const userAgent = navigator.userAgent;
  let ipData = { ip: 'unknown' };

  try {
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    ipData = await ipResponse.json();
    if (ipData.ip === undefined) {
      throw new Error('Failed to get IP address');
    }
  } catch (e) {
    console.error('Failed to get IP address', e);
    ipData = { ip: 'unknown' };
  }

  sendAnalytics({
    name: 'host-install-download',
    role: 'host',
    persistentId: getPersistentPlayerId(),
    userAgent: userAgent,
    ipAddress: ipData.ip,
  });
  window.open(config.DOWNLOAD_URL, '_self');
};
